import React from "react"

import { useEvent } from "shared/lib/useEvent"
import { SelectOption } from "shared/types/Select"

import { Checkbox, CheckboxProps } from "./Checkbox"

interface CheckboxListCheckboxProps<T> extends Omit<CheckboxProps, "onChange"> {
  option: SelectOption<T>
  onChange: (value: T) => void
  ref?: React.Ref<HTMLInputElement>
}

function CheckboxListCheckboxComponent<T>({
  id,
  option,
  onChange,
  ref,
  ...rest
}: CheckboxListCheckboxProps<T>) {
  const handleChange = useEvent(() => {
    onChange(option.value)
  })

  return (
    <Checkbox
      id={id}
      ref={ref}
      onChange={handleChange}
      label={option.label}
      {...rest}
    />
  )
}

export const CheckboxListCheckbox = React.memo(
  CheckboxListCheckboxComponent
) as typeof CheckboxListCheckboxComponent
